module.exports = __webpack_public_path__ + "static/media/CodeBerry.7bd5098e.svg";